import { PropsWithChildren } from 'react';
import { Checkbox } from '@rootCommon/components';
import './DataListItemSelectable.scss';

type Props = {
  value?: boolean;
  checkItem: (checked: boolean) => void;
};

const DataListItemSelectable = ({ children, value, checkItem }: PropsWithChildren<Props>): JSX.Element => (
  <div className="DataListItemSelectable">
    <div className="item-list-checkbox">
      <Checkbox onChangeValue={checkItem} value={value} />
    </div>
    <div className="item-list-content">{children}</div>
  </div>
);

export default DataListItemSelectable;
